import React, { useCallback, useEffect, useState } from "react";
import { Grid } from "@mui/material";
import { useWidth } from "../../../../../libs/hooks";
import { message } from "antd";
import { CardComponent } from "./card-component";
import { workflowTwoCount } from "../../../../../libs/apis";
import { CardWelcomeComponent } from "./card-welcome";
import WorkflowTwoListComponent from "./table-process-two";

interface DataType {
  key: React.Key;
  name: string;
  age: number;
  address: string;
}

export const ProcessTwoComponent = ({ options }: { options: any[] }) => {
  const width = useWidth();
  const [valueTwo, setValueTwo] = useState("Hoy");
  const [totalTwo, setTotalTwo] = useState(0);

  useEffect(() => {
    handleGetData();
  }, []);

  const handleGetData = async () => {
    try {
      handleGetTwo("hoy");
    } catch (err: any) {
      message.error(err.toString());
    }
  };

  const handleUpdateTwo = useCallback(
    (val: string) => {
      const fill = options.find((el) => el.value === val);
      setValueTwo(fill.label);
      handleGetTwo(fill.value);
    },
    [options]
  );

  const handleGetTwo = async (value: string) => {
    try {
      const { data: dataTwo } = await workflowTwoCount(value);
      if (!dataTwo) return;
      setTotalTwo(dataTwo.total);
    } catch (err: any) {
      message.error(err.toString());
    }
  };

  return (
    <Grid container spacing={5} justifyContent="center">
      <Grid item xs={7} sm={4} lg={3}>
        <CardWelcomeComponent />
      </Grid>
      <Grid item xs={5} sm={2.5}>
        <CardComponent
          width={width}
          title="Proceso 2"
          quantity={totalTwo}
          handleUpdate={handleUpdateTwo}
          options={options}
          color="tomato"
          value={valueTwo}
        />
      </Grid>
      <Grid item xs={12}>
        <WorkflowTwoListComponent />
      </Grid>
    </Grid>
  );
};
